var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading box_renew-loading" }, [
      _c("div", { staticClass: "loading-wrap" }, [
        _c("span", { staticClass: "box_loading-area" }, [
          _c("img", {
            attrs: { src: require("../images/loading.gif"), alt: "로딩중" }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df628658", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df628658","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyLoading.vue
// module id = null
// module chunks = 